import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'
import '../../css/carousel-matrix.css'

const $carousel = document.querySelector('.carousel-matrix')

const carouselMatrix = new Swiper('.carousel-matrix', {
  loop: true,
  autoplay: false,
  speed: 1000,
  pagination: {
    el: '.swiper-pagination',
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    320: {
      spaceBetween: 64,
    },
    750: {
      spaceBetween: 64,
    },
  },
})
